import React, { useState, useEffect } from 'react';
import Footer from '../../components/Footer';
import Sidebar from './Side bar/Sidebar';
import DashboardContent from './dashboard/DashboardContent';
import MyLoadsContent from './my cargo/MyLoadsContent';
import FavoritesContent from './favorites/FavoritesContent';
import SupportContent from './Support/SupportContent';
import { motion, AnimatePresence } from 'framer-motion';



export default function Dashboard() {
    // مقدار اولیه را از localStorage بخوان
    const [active, setActive] = useState(() => {
        if (typeof window !== 'undefined') {
            return localStorage.getItem('dashboard_active_tab') || 'dashboard';
        }
        return 'dashboard';
    });

    // هر بار تغییر، مقدار را ذخیره کن
    useEffect(() => {
        if (typeof window !== 'undefined') {
            localStorage.setItem('dashboard_active_tab', active);
        }
    }, [active]);

    let content;
    if (active === 'dashboard') content = <DashboardContent  />;
    else if (active === 'myloads') content = <MyLoadsContent  />;
    else if (active === 'favorites') content = <FavoritesContent  />;
    else if (active === 'support') content = <SupportContent />;

    return (
        <>
            <main className="relative w-full min-h-screen flex flex-col lg:flex-row py-10 ">
                {/* Sidebar */}
                <div className="w-full p-4 md:py-10 md:px-14 lg:w-72 flex-shrink-0">
                    <Sidebar active={active} setActive={setActive} />
                </div>

                {/* Content */}
                <AnimatePresence mode="wait">
                    <motion.section
                        key={active}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.4 }}
                        className="m-4 md:mx-12 md:mt-0 lg:mx-24 lg:my-12  flex-1 p-1 md:p-5 flex flex-col lg:justify-center justify-start items-center"
                    >
                        {content}
                    </motion.section>
                </AnimatePresence>
            </main>
            <Footer />
        </>
    );
}